import { Blob } from "../components/Blob";
import { PortalDemo } from "../components/PortalDemo";
import { SectionHead } from "../components/SectionHead";
import { WaitlistForm } from "../components/WaitlistForm";
import { copy } from "../content/copy";

export function PortalSection() {
  const c = copy.portal;
  return (
    <section className="section portal-section" id="portal">
      <Blob color="orange" position="tl" />
      <Blob color="lime" position="br" />
      <div className="container portal-section__inner">
        <SectionHead
          eyebrow={c.eyebrow}
          title={
            <>
              Build the interview <span className="serif-italic">once</span>. Run it for every
              candidate.
            </>
          }
          lede={c.lede}
        />

        <PortalDemo />

        <div className="portal-compare">
          <article className="portal-compare__col">
            <h3 className="portal-compare__title">Ready to go</h3>
            <ul className="portal-compare__list">
              <li>Pick a domain, start in 30 seconds</li>
              <li>Pre-built problems and rubrics</li>
              <li>Best for teams new to structured niche interviews</li>
            </ul>
          </article>
          <article className="portal-compare__col">
            <h3 className="portal-compare__title">Build your own</h3>
            <ul className="portal-compare__list">
              <li>Configure every tool your team uses</li>
              <li>Write your own problem and criteria</li>
              <li>Best for teams with a specific, established dev environment</li>
            </ul>
          </article>
        </div>

        <div className="portal-cta">
          <h3 className="portal-cta__title">{c.ctaTitle}</h3>
          <div className="portal-cta__form-wrap">
            <WaitlistForm location="portal" ctaLabel="Get early access" />
          </div>
          <span className="portal-cta__privacy">No spam. Just early access.</span>
        </div>
      </div>
    </section>
  );
}
